import { Button, type ButtonProps } from "@medimo/ui";
import React from "react";
import { useSubscriptionActive } from "../hooks/use-subscription-active";

/**
 * `ProtectedButton` は、`useSubscriptionActive` フックを使用して、以下の条件で無効化されます:
 * - `disabled` プロパティが `true` の場合
 * - サブスクリプションがアクティブでない場合 (`isActive` が `false`)
 * - サブスクリプションの状態を取得中の場合 (`isPending` が `true`)
 *
 * @param disabled ボタンを手動で無効化するためのオプションプロパティ
 * @param props その他のボタンプロパティ
 * @param ref ボタン要素への参照
 *
 * @returns {JSX.Element} `Button` コンポーネント
 */
const ProtectedButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ disabled, ...props }, ref) => {
    const { isActive, isPending } = useSubscriptionActive();
    return (
      <Button
        ref={ref}
        disabled={disabled || !isActive || isPending}
        {...props}
      />
    );
  },
);

ProtectedButton.displayName = "ProtectedButton";

export { ProtectedButton };
